import { render, staticRenderFns } from "./PostsSelection.vue?vue&type=template&id=2fba56cb&scoped=true&"
import script from "./PostsSelection.vue?vue&type=script&lang=js&"
export * from "./PostsSelection.vue?vue&type=script&lang=js&"
import style0 from "./PostsSelection.vue?vue&type=style&index=0&id=2fba56cb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fba56cb",
  null
  
)

export default component.exports